export default class CommissionModel {
    public id: string;
    public name: string;
    public colli: number;
    public direct: number;
    public indirect: number;
    public level1: number;
    public level2: number;
    public level3: number;
    public level4: number;
    public level5: number;
    public level6: number;
    public level7: number;
    public level8: number;
    public diffTl: number;
    public diffRm: number;
    public diffLm: number;
    public diffDm: number;
    public diffGm: number;
    public diffPr: number;
    public mentor: number;
    public mentorCoach: number;
    public officeProfi: number;
    public officeProfiTl: number;
    public repesentative: number;
    public onexoneLocation: number;
    public kickstarter: number;
    public car1: number;
    public car2: number;
    public car3: number;
    public officeProfiLg: number;
    public officeProfiMlg: number;
    public operator: number;
    public operatorLg: number;
    public operatorMlg: number;
    public selfCommissionApplicable: boolean;
    public percentCalculation: boolean;
    public currencyIso: string;

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.colli = json.colli;
        this.direct = json.direct;
        this.indirect = json.indirect;
        this.level1 = json.level1;
        this.level2 = json.level2;
        this.level3 = json.level3;
        this.level4 = json.level4;
        this.level5 = json.level5;
        this.level6 = json.level6;
        this.level7 = json.level7;
        this.level8 = json.level8;
        this.diffTl = json.diffTl;
        this.diffRm = json.diffRm;
        this.diffLm = json.diffLm;
        this.diffDm = json.diffDm;
        this.diffGm = json.diffGm;
        this.diffPr = json.diffPr;
        this.mentor = json.mentor;
        this.mentorCoach = json.mentorCoach;
        this.officeProfi = json.officeProfi;
        this.officeProfiTl = json.officeProfiTl;
        this.repesentative = json.repesentative;
        this.onexoneLocation = json.onexoneLocation;
        this.kickstarter = json.kickstarter;
        this.car1 = json.car1;
        this.car2 = json.car2;
        this.car3 = json.car3;
        this.colli = json.colli;
        this.officeProfiLg = json.officeProfiLg;
        this.officeProfiMlg = json.officeProfiMlg;
        this.operator = json.operator;
        this.operatorLg = json.operatorLg;
        this.operatorMlg = json.operatorMlg;
        this.selfCommissionApplicable = json.selfCommissionApplicable;
        this.percentCalculation = json.percentCalculation;
        this.currencyIso = json.currencyIso || 'EUR';
    }

    calcSum(): number {
        return (
            this.direct +
            this.indirect +
            this.level1 +
            this.level2 +
            this.level3 +
            this.level4 +
            this.level5 +
            this.level6 +
            this.level7 +
            this.level8 +
            this.diffTl +
            this.diffRm +
            this.diffLm +
            this.diffDm +
            this.diffGm +
            this.diffPr +
            this.mentor +
            this.mentorCoach +
            this.officeProfi +
            this.officeProfiTl +
            this.repesentative +
            this.onexoneLocation +
            this.kickstarter +
            this.car1 +
            this.car2 +
            this.car3 +
            this.officeProfiLg +
            this.officeProfiMlg +
            this.operator +
            this.operatorLg +
            this.operatorMlg
        );
    }
}
